import classes from '../styles/style.module.css'

const ArbitrationSearch = ({ searchTerm, setSearchTerm }) => {
  return (
    <div className='mt-4'>
      <input
        type="text"
        placeholder="جستجوی اثر"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={classes.searchInput}
      />
    </div>
  )
}

export default ArbitrationSearch